import type {$Fetch} from "nitropack";
import baseRepository from "~/api/BaseRepository";
import type { SpokenLanguage } from "~/help/languages";

export interface CustomerPortalRequest {
    return_url: string;
}

export interface CustomerPortalResponse {
    url: string;
}

export interface CompareRadarPoint {
    label: string;
    value: number;
    count: number;
    validated_count: number;
}

export interface CompareRadars {
    industries: CompareRadarPoint[];
    market_segments: CompareRadarPoint[];
    company_sizes: CompareRadarPoint[];
    deal_sizes: CompareRadarPoint[];
}

export interface CompareExperience {
    id: string;
    company_name: string | null;
    title: string | null;
    start_at: string | null;
    end_at: string | null;
    is_ongoing: boolean;
}

export interface CompareExpert {
    id: string;
    first_name: string;
    last_name: string;
    handle: string | null;
    signed_picture_url: string | null;
    job_position: string | null;
    city: string | null;
    big_score: number | null;
    big_score_specialty: string | null;
    summary: string | null;
    signed_video_url: string | null;
    radars: CompareRadars;
    experiences: CompareExperience[];
    matching_score: number | null;
    languages: SpokenLanguage[];
}

export interface CompareExpertsResponse {
    experts: CompareExpert[];
}

export const UserRepository = (client: $Fetch) => ({
    ...baseRepository(client)('v2/users'),

    createCustomerPortalSession: (data: CustomerPortalRequest) => {
        return client('/v2/user/customer-portal', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            }
        }) as Promise<CustomerPortalResponse>
    },

    getVisibility: (slug: string) => {
        return client(`/v2/users/${slug}/visibility`, {
            method: 'GET',
        }) as Promise<{ is_visible: boolean }>;
    },

    compare: (ids: string[], missionId?: string): Promise<CompareExpertsResponse> => {
        const params = new URLSearchParams({ ids: ids.join(',') });
        if (missionId) params.set('mission_id', missionId);
        return client(`/v2/users/compare?${params.toString()}`, { method: 'GET' }) as Promise<CompareExpertsResponse>;
    },
})